import { ResponsivePie } from "@nivo/pie";

const PieChart = ({ data }) => {
  const alternative = [
    {
      id: "Intent 1",
      label: "Intent1",
      value: 100,
      color: "hsl(129, 70%, 50%)",
    },
    {
      id: "Intent 2",
      label: "Intent2",
      value: 100,
      color: "hsl(129, 70%, 50%)",
    },
  ];

  return (
    <div style={{ height: "400px" }}>
      <ResponsivePie
        height={400}
        data={data ? data : alternative}
        margin={{ top: 40, right: 200, bottom: 40, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        colors={{ scheme: "paired" }}
        borderColor={{ from: "color", modifiers: [["darker", 0.6]] }}
        radialLabelsSkipAngle={10}
        radialLabelsTextColor="#333333"
        radialLabelsLinkColor={{ from: "color" }}
        sliceLabelsSkipAngle={10}
        sliceLabelsTextColor="#333333"
        // colors={{ scheme: "nivo" }}
      />
    </div>
  );
};

export default PieChart;
